import LazyLoad, { LazyLoadProps } from 'react-lazyload'

const LazyLoadWrapper = ({ ...rest }: LazyLoadProps) => {
  // Above the fold usually 600px, we also add some extra spacer so maybe 800px
  return <LazyLoad once offset={1200} {...rest} />
}

export default LazyLoadWrapper
